'use client'

import classNames from 'classnames'
import React, { useCallback } from 'react'

import { useContactModal } from '~/contexts/contact-modal'

import { ClientButtonProperties } from '../types'

const ClientButton: React.FC<ClientButtonProperties> = ({
  text,
  textMobile,
  className,
  children,
  openContactModal,
  ...rest
}) => {
  const contactModal = useContactModal()

  const onClickButton = useCallback(() => {
    if (openContactModal) {
      contactModal.open()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactModal.open, openContactModal])

  return (
    <button
      className={classNames('button', className)}
      onClick={onClickButton}
      {...(rest as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {textMobile ? (
        <>
          <span className="hidden md:inline">{text}</span>
          <span className="md:hidden">{textMobile}</span>
        </>
      ) : (
        <>{text}</>
      )}
      {children}
    </button>
  )
}

export default ClientButton
